module.exports = __webpack_public_path__ + "img/west-vvip-gal-8.85f9ea77.jpg";